import React, { useEffect } from "react";
import "./Change_Nickname_modal.css";
import { Modal, Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { AuthUpdate, GETAuthLogin } from "../../../../../features/auth/Slice";

function Change_Nickname_modal({ ...props }) {
  const dispatch = useDispatch();

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      name: "",
    },
  });

  useEffect(() => { if (props?.user) reset(props?.user) }, [props?.user])

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append("name", data?.name);
      console.log(data);

      const res = await dispatch(AuthUpdate(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        await dispatch(GETAuthLogin());
        props.onHide();
        props?.setModalShow1(true);
        props?.setModalMessage("Name Updated Successfully");
        setTimeout(() => {
          props?.setModalShow1(false);
        }, 2000);
      } else {
        props?.setModalShow1(true);
        props?.setModalMessage(res?.payload?.errors);
        setTimeout(() => {
          props?.setModalShow1(false);
        }, 2000);
        console.error("Update failed:", res.error);
      }
    } catch (error) {
      console.error("Update nickname failed:", error);
    }
  };

  return (
    <>
      <Modal
        {...props}
        centered
        size="sm"
        backdrop="static"
        className="Change_Nickname_modal Common_modal"
        scrollable
      >
        <Modal.Body>
          <div className="upi_container">
            <div className="modal_header">Change Nickname</div>
            <div className="box_holder login-page">
              <Form onSubmit={handleSubmit(onSubmit)} noValidate>
                <div className="form-group field_holder">
                  <Form.Label>
                    <img
                      src="/assets/images/icons/user.png"
                      alt="icon"
                      className="login_lable_icons"
                    />
                    Nickname
                  </Form.Label>

                  <Form.Control
                    type="text"
                    placeholder="Enter new nickname"
                    {...register("name", {
                      required: "Nickname is required",
                      minLength: {
                        value: 3,
                        message: "Nickname must be at least 3 characters",
                      },
                      maxLength: {
                        value: 20,
                        message: "Nickname must be at most 20 characters",
                      },
                    })}
                  />
                  {errors.name && (
                    <small className="text-danger">{errors.name.message}</small>
                  )}
                </div>

                <div className="btn_holder mt-5">
                  <Button
                    type="submit"
                    className="btn_register_bg mb-3"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Updating..." : "Update"}
                  </Button>
                  <Button className="btn-register" onClick={props.onHide}>
                    Close
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Change_Nickname_modal;